export const VIDEO_PROVIDER = /** @type {const} */ ({
  YOUTUBE: 'YOUTUBE',
  BYTEARK: 'BYTEARK',
  VIMEO: 'VIMEO',
  MINDSTAMP: 'MINDSTAMP',
  LEARNCRAFT: 'LEARNCRAFT',
});

export const VIDEO_SOURCE_TYPE = {
  ONLINE: 'ONLINE',
  LOCAL: 'LOCAL',
};

export const MATERIAL_TYPE = {
  VIDEO_SLIDE: 'VIDEO_SLIDE',
  VIDEO: 'VIDEO',
  LIVE_VIDEO: 'LIVE_VIDEO',
  ARTICLE: 'ARTICLE',
  ASSIGNMENT: 'ASSIGNMENT',
  SLIDES: 'SLIDES',
  EXTERNAL: 'EXTERNAL',
  YOUTUBE: 'YOUTUBE',
  QUIZ: 'QUIZ',
  QUIZ_SIMPLE: 'QUIZ_SIMPLE',
  LIVECODING: 'LIVECODING',
  NOTEBOARD: 'NOTEBOARD',
  EBOOK: 'EBOOK',
  PDF: 'PDF',
  OTHER: 'OTHER',
  MATERIAL: 'MATERIAL',
};

export const SUBSECTION_TYPE = {
  VIDEO_SLIDE: 'VIDEO_SLIDE',
  VIDEO: 'VIDEO',
  LIVE_VIDEO: 'LIVE_VIDEO',
  ARTICLE: 'ARTICLE',
  ASSIGNMENT: 'ASSIGNMENT',
  SLIDES: 'SLIDES',
  EXTERNAL: 'EXTERNAL',
  QUIZ: 'QUIZ',
  QUIZ_SIMPLE: 'QUIZ_SIMPLE',
  LIVECODING: 'LIVECODING',
  NOTEBOARD: 'NOTEBOARD',
  EBOOK: 'EBOOK',
  OTHER: 'OTHER',
  MATERIAL: 'MATERIAL',
  FULL_LESSON: 'FULL_LESSON',
  SUMMARY_LESSON: 'SUMMARY_LESSON',
};

// Only these are locked when learning time runs out; quizzes and solutions stay open
export const TIME_UP_LOCKED_TYPES = [SUBSECTION_TYPE.VIDEO, SUBSECTION_TYPE.VIDEO_SLIDE];

export const CONTENT_DATA = {
  VIDEOTIME: 'VIDEOTIME',
};

// MediaError code reference: https://docs.videojs.com/mediaerror
export const VIDEO_ERROR_TYPE = {
  MEDIA_ERR_ABORTED: 1,
  MEDIA_ERR_NETWORK: 2,
  MEDIA_ERR_DECODE: 3,
  MEDIA_ERR_SRC_NOT_SUPPORTED: 4,
  MEDIA_ERR_ENCRYPTED: 5,
};

export const SCREEN_ORIENTATION = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
};

export const EXAM_TAG_CATEGORY = {
  EXAM_TYPE: 'EXAM_TYPE',
};
